import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.userLogout();
                location.reload();
            }

            if (err.status === 403) {
                // Authorization rejection: authenticated but not permitted.
                // Navigate to the unauthorized page (this interceptor OWNS the
                // 403 -> unauthorized navigation) and do NOT log out.
                const message = err.error?.message || 'You are not permitted to perform this action.';
                console.warn('[RBAC 403]', message);
                this.router.navigate(['/pages/unauthorized']);
                // Emit the error so component-level handlers can show a toast/alert.
                return throwError(() => ({ status: 403, message }));
            }

            if (err.status === 422) {
                // Could be an org-required rejection for Superadmin.
                const message = err.error?.message || 'Validation error.';
                const isOrgRequired = message.toLowerCase().includes('organization must be selected');
                if (isOrgRequired) {
                    console.warn('[RBAC 422] Organization selection required');
                    // Propagate so the component/page can prompt the selector.
                }
                // Preserve the per-field validation errors (data) so component
                // handlers can flag the specific fields (e.g. email already taken).
                return throwError(() => ({ status: 422, message, isOrgRequired, data: err.error?.data }));
            }

            const error = err.error?.message || err.statusText;
            return throwError(error);
        }))
    }
}
